import { defineMessages } from "react-intl";

export const FormPasscodeRequiredText = defineMessages({
  description: {
    defaultMessage:
      "You can obtain the passcode from an authorized SmartSuite Admin or Solution Manager",
    id: "ujD4hx",
  },
  enterPassword: {
    defaultMessage: "Enter Password",
    id: "A41QIy",
  },
  enter: {
    defaultMessage: "Enter",
    id: "H8KGyc",
  },
  passcodeIsIncorrect: {
    defaultMessage: "The passcode you entered is incorrect",
    id: "v5m19p",
  },
});
